export default function Title() {
  return (
    <div className="Title">
        <h1>Hi, I'm Alex Stocking</h1>
        <h5>A junior software engineer with a background in education.</h5>
    </div>
  )
}
